import { controls } from "../../controls";
const atm_issue_rp2 = {
  label: "Atm Issue",
  starting: true,
  url: "atm_issue_2",
  pageLabel: "Atm Issue 2",
  pageType: "history",
  // filteraction: true,
  filter: [
    //...controls.magicDateLabel({ tab: "filter", star: true, label: "As On Date", width: "col-sm-2", target: "as_on_date" }),
    //...controls.magicDate({ tab: "filter", name: "as_on_date", width: "col-sm-2", dateType: "ontype", isRequired: true, default: "n" }),

    ...controls.displayText({ tab: "filter", label: "Open Date" }),
    ...controls.text({ tab: "filter", placeHolder: "", name: "open_date", maxlength: 10, placeHolder: "(EX.20220730)" }),


  ],
  form: [],
  history: {
    perPage: 10,
    reportHeader: "Atm Issue",
    filterable: true,
    sortable: true,
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    textReportProps: {
      'LBS': {
        filename: `atm_issue_2-$pageData.as_on_date$.txt`,
        format: {},
        separator: "|"
      },
    },
    displayColumns: [
      {
        Header: "Card Number",
        accessor: "card_number",
      },
      {
        Header: "Saving Account Number",
        accessor: "saving_account_number",
      },
      {
        Header: "Current Account Number",
        accessor: "current_account_number",
      },
      {
        Header: "CC Account Number",
        accessor: "cc_account_number",
      },
      {
        Header: "'Embossed Name (Name to be printed on card)",
        accessor: "embossed_name",
      },
      {
        Header: "First Name",
        accessor: "first_name",
      },
      {
        Header: "Middle Name",
        accessor: "middle_name",
      },

      {
        Header: "Last Name (Surname)",
        accessor: "last_name",
      },
      {
        Header: "Address Line 1",
        accessor: "address_line_1",
      },
      {
        Header: "Address Line 2",
        accessor: "address_line_2",
      },
      {
        Header: "Address Line 3",
        accessor: "address_line_3",
      },
      {
        Header: "City",
        accessor: "city",
      },
      {
        Header: "State",
        accessor: "state",
      },
      {
        Header: "Pin Code",
        accessor: "PinCode",
      },
      {
        Header: "Mobile Number",
        accessor: "account_holder_mobile_number",
      },
      {
        Header: "Branch Id",
        accessor: "branch_id",
      },
      {
        Header: "Branch Name",
        accessor: "branch_name",
      },
      {
        Header: "'Want to receive SMS transaction alerts? Y/N'",
        accessor: "want_sms",
      },



    ]
  }
};
export default atm_issue_rp2;